import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import s from './FeaturedPayPalSuccess.css';
import messages from '../../../../locale/messages';
import Loader from '../../../../components/Loader/Loader';
import Link from '../../../../components/Link/Link';

const COMPLETE_PAYPAL_PAYMENT = gql`
  mutation completeFeaturedPayPalPayment(
    $orderId: String!
    $listId: Int!
    $bidAmount: Float
    $autoRenew: Boolean
    $billingCountry: String
    $billingName: String
    $billingZipcode: String
    $tier: String
  ) {
    completeFeaturedPayPalPayment(
      orderId: $orderId
      listId: $listId
      bidAmount: $bidAmount
      autoRenew: $autoRenew
      billingCountry: $billingCountry
      billingName: $billingName
      billingZipcode: $billingZipcode
      tier: $tier
    ) {
      status
      featuredListingId
      errorMessage
    }
  }
`;

class FeaturedPayPalSuccess extends Component {
  static propTypes = {
    orderId: PropTypes.string,
    featuredData: PropTypes.object
  };

  state = {
    loading: true,
    success: false,
    error: null,
    featuredListingId: null
  };

  async componentDidMount() {
    await this.completePayment();
  }

  completePayment = async () => {
    const { orderId, featuredData, mutate } = this.props;

    if (!orderId || !featuredData?.listId) {
      this.setState({ 
        loading: false, 
        error: 'Datos de pago incompletos. Por favor intenta de nuevo.' 
      });
      return;
    }

    try {
      const result = await mutate({
        variables: {
          orderId,
          listId: featuredData.listId,
          bidAmount: featuredData.bidAmount || 0,
          autoRenew: featuredData.autoRenew || false,
          billingCountry: featuredData.billingCountry,
          billingName: featuredData.billingName,
          billingZipcode: featuredData.billingZipcode,
          tier: featuredData.tier || 'standard'
        }
      });

      if (result?.data?.completeFeaturedPayPalPayment?.status === 'success') {
        this.setState({ 
          loading: false, 
          success: true,
          featuredListingId: result.data.completeFeaturedPayPalPayment.featuredListingId
        });
      } else {
        this.setState({ 
          loading: false, 
          error: result?.data?.completeFeaturedPayPalPayment?.errorMessage || 'Error al procesar el pago'
        });
      }
    } catch (err) {
      console.error('Error completing PayPal payment:', err);
      this.setState({ 
        loading: false, 
        error: 'Error inesperado. Por favor contacta soporte.' 
      });
    }
  };

  render() {
    const { loading, success, error } = this.state;
    const { featuredData } = this.props;

    return (
      <div className={s.container}>
        <div className={s.card}>
          {loading && (
            <div className={s.loadingState}>
              <Loader type="text" />
              <h2 className={s.title}>Procesando tu pago...</h2>
              <p className={s.subtitle}>Por favor espera mientras confirmamos tu pago con PayPal.</p>
            </div>
          )}

          {!loading && success && (
            <div className={s.successState}>
              <div className={s.successIcon}>✓</div>
              <h2 className={s.title}>¡Pago Exitoso!</h2>
              <p className={s.subtitle}>
                Tu bote ahora está destacado y aparecerá en la página principal.
              </p>
              <div className={s.details}>
                <div className={s.detailRow}>
                  <span>Total pagado:</span>
                  <strong>${featuredData?.totalAmount?.toFixed(2) || '99.00'}</strong>
                </div>
                <div className={s.detailRow}>
                  <span>Duración:</span>
                  <strong>30 días</strong>
                </div>
              </div>
              <div className={s.actions}>
                <Link to="/user/boats" className={s.primaryButton}>
                  Ver Mis Botes
                </Link>
                <Link to="/" className={s.secondaryButton}>
                  Ir al Inicio
                </Link>
              </div>
            </div>
          )}

          {!loading && error && (
            <div className={s.errorState}>
              <div className={s.errorIcon}>✕</div>
              <h2 className={s.title}>Error en el Pago</h2>
              <p className={s.subtitle}>{error}</p>
              <div className={s.actions}>
                <Link to="/user/boats" className={s.primaryButton}>
                  Volver a Mis Botes
                </Link>
                <Link to="/contact" className={s.secondaryButton}>
                  Contactar Soporte
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(COMPLETE_PAYPAL_PAYMENT)
)(FeaturedPayPalSuccess);
